import { init } from '@sentry/browser';

const DSN = 'https://75786e51fd834ac5a70737db81a4b9d8@sentry.io/1803156';

function getEnvironmentId(host) {
  if (host === 'insights.hotjar.com') {
    return 'live';
  }

  if (host === 'insights-staging.hotjar.com') {
    return 'staging';
  }

  const [, , reviewEnvId] = host.match(/^insights-(.+)\.live\.eks\.hotjar\.com$/) ?? [];

  if (reviewEnvId) {
    return reviewEnvId;
  }

  return 'dev';
}

init({
  dsn: DSN,
  environment: getEnvironmentId(document.location.host),
  allowUrls: [/insights\.hotjar\.com/],
  integrations: [],
  release: `insights-frontend-${process.env.WEBAPP_VERSION}`,
  sampleRate: 0.25,
});
